import { SVGProps } from "react";

export interface FileTypeThumbnailIconProps
  extends SVGProps<SVGSVGElement> {
  label: string;
  accentColor?: string;
}

export default function FileTypeThumbnailIcon(
  props: FileTypeThumbnailIconProps,
) {
  const {
    width = 40,
    height = 40,
    label,
    accentColor = "#667085",
    ...rest
  } = props;
  const normalizedLabel = label.trim().toUpperCase().slice(0, 5);
  const fontSize =
    normalizedLabel.length <= 3 ? 7.25 : normalizedLabel.length === 4 ? 6 : 5;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11 0.75H27C27.1212 0.75 27.2375 0.798088 27.3232 0.883789L38.1162 11.6768C38.2019 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4C7.75 2.20507 9.20508 0.75 11 0.75Z"
        fill="white"
        stroke="#D0D5DD"
        strokeWidth="1.5"
      />
      <path
        d="M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5"
        stroke="#D0D5DD"
        strokeWidth="1.5"
      />
      <rect x="1" y="18" width="26" height="16" rx="2" fill={accentColor} />
      <text
        x="14"
        y="26.5"
        fill="white"
        fontFamily="Arial, sans-serif"
        fontSize={fontSize}
        fontWeight="700"
        letterSpacing="-0.15"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        {normalizedLabel}
      </text>
    </svg>
  );
}
